import { useQuery } from '@tanstack/react-query';
import { loadCookbookSnippetSkillsPageData } from '../services/profileAchievementStatsService';

export const COOKBOOK_SNIPPET_SKILLS_QUERY_KEY = 'cookbookSnippetSkills';

const SKILLS_STALE_MS = 3 * 60 * 1000;
const SKILLS_GC_MS = 15 * 60 * 1000;

const emptySkillsData = {
  totalSnippets: 0,
  avgMastery: 0,
  avgSnippetLevel: 0,
  snippetsMastered: 0,
  snippets: []
};

/**
 * Cached profile Skills snippet list (scoped by language).
 * Keeps prior rows visible while the language filter refetches.
 */
export default function useCookbookSnippetSkills(userId, languageFilter, { enabled = true } = {}) {
  const lang = languageFilter || '';
  const uid = typeof userId === 'string' ? userId.trim() : '';

  return useQuery({
    queryKey: [COOKBOOK_SNIPPET_SKILLS_QUERY_KEY, uid, lang],
    queryFn: () => loadCookbookSnippetSkillsPageData(uid, lang),
    enabled: Boolean(uid && enabled),
    staleTime: SKILLS_STALE_MS,
    gcTime: SKILLS_GC_MS,
    placeholderData: (previousData) => previousData ?? emptySkillsData
  });
}
